import { i18n } from '@/i18n'

export default (params) => {
  return [
    {
      icon: 'certificates',
      name: i18n.t('certificates.header'),
      path: 'certificates',
      use_parent_params: true,
      params_required: ['idEmpresa', 'serial', 'tipo'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'certificates/detail',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('companies.companies_link'),
          path: 'certificates/companies',
          params,
          registerNavFromMenu: false,
          disabled: params.idCliente === -1 || params.idCliente === '-1' || params.serial === -1 || params.SerialNumber === '-1' || params.TipoCertificado === -1 || params.TipoCertificado === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('historical.entity_name'),
          path: 'certificates/historical',
          params,
          registerNavFromMenu: false,
          disabled: params.idCliente === -1 || params.idCliente === '-1' || params.serial === -1 || params.SerialNumber === '-1' || params.TipoCertificado === -1 || params.TipoCertificado === '-1',
          sc: [] // shorcuts
        }
      ]
    }
  ]
}
